import { Divider } from '@mui/material';
import { styled } from '@/core/ui';
import { isDevelopmentMode } from '@/shared/helpers';
// TODO: FINISH RESTYLING // TODO: to delete all comments later
// const menuItemIconSize = '20px';
const menuItemIconSize = '1.25rem';
export const GpLogoContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    textWrap: 'nowrap',
    gap: '.75rem',
    width: '100%',
    color: theme.palette.text.primary,
    // paddingTop: '.5rem',
    // paddingBottom: '.5rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    fontFamily: 'GetVoIP Grotesque',
    fontSize: theme.typography.h6.fontSize,
    // '> img': {
    // 	filter: 'blur(0.2px) opacity(90%)',
    // 	width: '90%',
    // },
}));
export const GpPatternContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    // flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    //maxHeight: '70px',
    // Green marks a local run, so a local tab is never confused with a tab of the stand.
    backgroundColor: isDevelopmentMode() ? theme.palette.success.lighter : theme.palette.yellow.lighter,
    // BlackYellow version
    // backgroundColor: theme.palette.text.secondary,
    // color: theme.palette.text.primary,
    // paddingTop: '.5rem',
    // paddingBottom: '.5rem',
    // '> img': {
    // 	//filter: 'invert(48%) sepia(13%) saturate(3207%) hue-rotate(130deg) brightness(95%) contrast(80%)',
    // 	// filter: 'blur(0.3px) opacity(90%)',
    // 	filter: 'blur(0.2px) opacity(90%)',
    // 	width: '90%',
    // },
    height: '1.75rem',
    width: '1.875rem',
    minWidth: '1.875rem',
    borderRadius: `var(--gp-radius-md)`,
    color: theme.palette.common.black,
    // outlineColor: rgb( / var(--ring-opacity));
    outlineStyle: 'solid',
    // BlackYellow version
    // outlineColor: alpha(theme.palette.common.black, 0.1),
    // outlineColor: alpha(theme.palette.yellow.main, 0.55),
    outlineColor: `color-mix(in oklab, ${theme.vars.palette.yellow.main} 55%, transparent)`,
    outlineOffset: '-1px',
    outlineWidth: '1px',
    '> svg': {
        // BlackYellow version
        // color: theme.palette.yellow.lighter,
        width: '1.5rem',
        height: '1.5rem',
        color: theme.palette.text.primary,
    },
}));
export const SidebarSectionName = styled('span', { shouldForwardProp: (prop) => prop !== 'isFirst' && prop !== 'hidden' })(({ theme, isFirst, hidden }) => ({
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '1.5rem',
    padding: '0 1.55rem',
    marginBottom: '.25rem',
    marginTop: isFirst ? '.5rem' : '1.5rem',
    fontSize: theme.typography.helper.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.muted,
    opacity: hidden ? 0 : 1,
}));
export const SidebarDivider = styled(Divider)(({ theme }) => ({
    // borderColor: alpha(theme.palette.divider, 0.05),
    borderColor: `color-mix(in oklab, ${theme.vars.palette.divider} 5%, transparent)`,
    marginTop: '1rem',
    marginBottom: '1rem',
}));
export const SidebarToggleButtonContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'collapsed' })(({ collapsed }) => ({
    display: 'flex',
    justifyContent: collapsed ? 'center' : 'flex-end',
    padding: '0 1rem 0 .563rem',
}));
export const UserProfileButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem .5rem',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    // borderTopColor: alpha(theme.palette.divider, 0.05),
    borderTopColor: `color-mix(in oklab, ${theme.vars.palette.divider} 5%, transparent)`,
}));
export const getSidebarRootStyles = (sidebarTransitionDuration, sidebarTransitionTimingFunction) => ({
    display: 'flex',
    zIndex: '1000',
    position: 'fixed',
    height: '100%',
    //transition: width,left,right,300ms;
    transition: 'unset',
    transitionProperty: 'width,min-width,left,right',
    transitionDuration: sidebarTransitionDuration,
    transitionTimingFunction: sidebarTransitionTimingFunction,
    borderRightWidth: 0,
    '.ps-sidebar-container': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
});
export const menuRootStyles = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'flex-start',
    overflowY: 'auto',
    overflowX: 'hidden',
    '> ul': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: '.125rem',
        // Important
        width: '100%',
    },
};
export const menuItemRootStyles = {
    display: 'flex',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    // transition: 'all .25s ease',
};
export const getMenuItemButtonStyles = (active, collapsed, theme) => ({
    width: '100%',
    // height: '2.75rem',
    // height: '2.5rem',
    height: 'unset',
    paddingLeft: theme.spacing(collapsed ? 3 : 4),
    paddingRight: theme.spacing(2),
    fontSize: theme.typography.body1.fontSize, // '.8125rem',
    //new
    padding: theme.spacing(2),
    // gap: collapsed ? 'unset' : '.75rem',
    gap: theme.spacing(3),
    borderRadius: `var(--gp-radius-lg)`,
    // ':hover': {
    // 	backgroundColor: theme.palette.background.default,
    // 	// ' > .ps-menu-label': {
    // 	' > *': {
    // 		color: theme.palette.primary.main,
    // 	},
    // },
    ':hover': {
        // backgroundColor: alpha(theme.palette.text.primary, 0.05),
        backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 5%, transparent)`,
        // ' > .ps-menu-label': {
        // ' > *': {
        // 	color: theme.palette.primary.main,
        // },
        '.ps-menu-icon': {
            color: theme.palette.text.primary,
        },
    },
    ':focus-visible': {
        outline: 0,
        outlineOffset: 0,
    },
    ...(collapsed && {
        width: '2.4rem',
    }),
    ...(active && {
        // backgroundColor: alpha(theme.palette.text.primary, 0.05),
        backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 5%, transparent)`,
        ...(collapsed && {
            backgroundColor: `color-mix(in oklab, ${theme.vars.palette.primary.dark} 10%, transparent)`,
        }),
    }),
    // transition: 'all .25s ease',
});
export const getMenuItemPrefixStyles = (active, theme) => ({
    display: active ? 'inline' : 'none',
    position: 'absolute',
    width: '.125rem',
    left: '-1rem',
    top: '.5rem',
    bottom: '.5rem',
    borderRadius: '9999px',
    backgroundColor: theme.palette.text.primary,
    // not working
    // transition: 'transform .3s ease',
    // transform: 'translate(0, -50%);',
    // To make prefix visible when sidebar is collapsed.
    height: menuItemIconSize,
    opacity: 1,
    // transform: 'none',
    // transformOrigin: '50% 50% 0px',
});
export const getMenuItemIconStyles = (active, collapsed, theme) => ({
    color: active ? (collapsed ? theme.palette.primary.dark : theme.palette.text.primary) : theme.palette.zinc[500],
    height: menuItemIconSize,
    width: menuItemIconSize,
    minHeight: menuItemIconSize,
    minWidth: menuItemIconSize,
    marginRight: 0,
    lineHeight: menuItemIconSize,
});
export const getMenuItemLabelStyles = (active, collapsed, theme) => ({
    // color: active ? theme.palette.primary.dark : theme.palette.text.medium,
    color: theme.palette.text.primary,
    // fontWeight: active ? theme.typography.fontWeightMedium : undefined,
    fontWeight: theme.typography.fontWeightMedium,
    display: collapsed ? 'none' : undefined,
    lineHeight: '1.25rem',
    ...(theme.palette.mode === 'dark' && {
        fontWeight: theme.typography.fontWeightRegular,
    }),
});
